import React, { useMemo, useState } from "react";
import CardMobile from "./CardMobile";

// Formata o valor guardado no histórico para texto legível — trata
// booleanos, null/undefined e valores vazios de forma amigável, em vez
// de mostrarem "true"/"false"/"" sem contexto.
function formatarValorHistorico(valor) {
  if (valor === null || valor === undefined || valor === "") return "—";
  if (valor === true) return "Sim";
  if (valor === false) return "Não";
  return String(valor);
}

function formatarDataHora(timestamp) {
  if (!timestamp) return "-";
  const d = new Date(timestamp);
  const dataStr = d.toLocaleDateString("pt-PT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const horaStr = d.toLocaleTimeString("pt-PT", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${dataStr}, ${horaStr}`;
}

const CHAVE_SESSAO_DESBLOQUEADO = "historico_edicoes_desbloqueado";

export default function HistoricoEdicoes({ historico, senhaCorreta }) {
  const [desbloqueado, setDesbloqueado] = useState(
    () => sessionStorage.getItem(CHAVE_SESSAO_DESBLOQUEADO) === "true"
  );
  const [tentativaSenha, setTentativaSenha] = useState("");
  const [erroSenha, setErroSenha] = useState(false);

  const handleDesbloquear = (e) => {
    e.preventDefault();
    if (senhaCorreta && tentativaSenha === senhaCorreta) {
      sessionStorage.setItem(CHAVE_SESSAO_DESBLOQUEADO, "true");
      setDesbloqueado(true);
      setErroSenha(false);
    } else {
      setErroSenha(true);
    }
  };

  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroTexto, setFiltroTexto] = useState("");
  const [filtroDataDe, setFiltroDataDe] = useState("");
  const [filtroDataAte, setFiltroDataAte] = useState("");

  const tiposDisponiveis = useMemo(() => {
    const lista = new Set();
    historico.forEach((h) => h.tipo && lista.add(h.tipo));
    return [...lista].sort();
  }, [historico]);

  const historicoFiltrado = useMemo(() => {
    return historico.filter((h) => {
      if (filtroTipo && h.tipo !== filtroTipo) return false;
      if (
        filtroTexto &&
        !String(h.contexto || "")
          .toLowerCase()
          .includes(filtroTexto.toLowerCase())
      )
        return false;
      if (filtroDataDe) {
        const dInicio = new Date(`${filtroDataDe}T00:00:00`);
        if (h.timestamp < dInicio.getTime()) return false;
      }
      if (filtroDataAte) {
        const dFim = new Date(`${filtroDataAte}T23:59:59`);
        if (h.timestamp > dFim.getTime()) return false;
      }
      return true;
    });
  }, [historico, filtroTipo, filtroTexto, filtroDataDe, filtroDataAte]);

  const limparFiltros = () => {
    setFiltroTipo("");
    setFiltroTexto("");
    setFiltroDataDe("");
    setFiltroDataAte("");
  };

  if (!desbloqueado) {
    return (
      <div
        style={{
          background: "#ffffff",
          padding: "40px",
          borderRadius: "16px",
          boxShadow: "0 4px 18px rgba(15, 23, 42, 0.04)",
          maxWidth: "360px",
          margin: "40px auto",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "32px", marginBottom: "8px" }}>🔒</div>
        <h2
          style={{
            margin: "0 0 6px 0",
            fontSize: "16px",
            fontWeight: "800",
            color: "#0f172a",
          }}
        >
          Área Protegida
        </h2>
        <p style={{ margin: "0 0 20px 0", fontSize: "13px", color: "#64748b" }}>
          Introduz a password para veres o Histórico de Edições.
        </p>
        <form onSubmit={handleDesbloquear}>
          <input
            type="password"
            value={tentativaSenha}
            onChange={(e) => {
              setTentativaSenha(e.target.value);
              setErroSenha(false);
            }}
            placeholder="Password"
            autoFocus
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "8px",
              border: erroSenha ? "1px solid #ef4444" : "1px solid #cbd5e1",
              fontSize: "14px",
              boxSizing: "border-box",
              marginBottom: "12px",
            }}
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#7c3aed",
              color: "#fff",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Entrar
          </button>
        </form>
        {erroSenha && (
          <p style={{ marginTop: "12px", fontSize: "12px", color: "#ef4444" }}>
            Password incorreta.
          </p>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        background: "#ffffff",
        padding: "24px",
        borderRadius: "16px",
        boxShadow: "0 4px 18px rgba(15, 23, 42, 0.04)",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "15px",
          borderBottom: "1px solid #f1f5f9",
          paddingBottom: "16px",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: "14px",
              fontWeight: "700",
              color: "#0f172a",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            📜 Histórico de Edições da Equipa
          </h2>
          <p
            style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b" }}
          >
            Últimas {historico.length} edições registadas ·{" "}
            <strong>{historicoFiltrado.length}</strong> a mostrar
          </p>
        </div>
        <button
          onClick={limparFiltros}
          style={{
            padding: "8px 12px",
            border: "1px solid #cbd5e1",
            borderRadius: "6px",
            backgroundColor: "#fff",
            color: "#64748b",
            fontSize: "12px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Limpar Filtros
        </button>
      </div>

      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >
        <div style={{ flex: "1 1 160px", minWidth: "160px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontWeight: "700",
              fontSize: "12px",
              color: "#475569",
            }}
          >
            Tipo de Edição:
          </label>
          <select
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              fontSize: "13px",
            }}
          >
            <option value="">-- Todos --</option>
            {tiposDisponiveis.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>
        <div style={{ flex: "1 1 200px", minWidth: "200px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontWeight: "700",
              fontSize: "12px",
              color: "#475569",
            }}
          >
            Procurar (apt, quarto, id...):
          </label>
          <input
            type="text"
            value={filtroTexto}
            onChange={(e) => setFiltroTexto(e.target.value)}
            placeholder="Ex: PR12, S5_7..."
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              fontSize: "13px",
              boxSizing: "border-box",
            }}
          />
        </div>
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontWeight: "700",
              fontSize: "12px",
              color: "#475569",
            }}
          >
            De:
          </label>
          <input
            type="date"
            value={filtroDataDe}
            onChange={(e) => setFiltroDataDe(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              fontSize: "13px",
            }}
          />
        </div>
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontWeight: "700",
              fontSize: "12px",
              color: "#475569",
            }}
          >
            Até:
          </label>
          <input
            type="date"
            value={filtroDataAte}
            onChange={(e) => setFiltroDataAte(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              fontSize: "13px",
            }}
          />
        </div>
      </div>

      <div
        className="tabela-desktop"
        style={{
          overflowX: "auto",
          width: "100%",
          borderRadius: "8px",
          border: "1px solid #e2e8f0",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <th style={{ padding: "12px 14px", color: "#475569", fontWeight: "700" }}>
                Quando
              </th>
              <th style={{ padding: "12px 14px", color: "#475569", fontWeight: "700" }}>
                Tipo de Edição
              </th>
              <th style={{ padding: "12px 14px", color: "#475569", fontWeight: "700" }}>
                Contexto
              </th>
              <th style={{ padding: "12px 14px", color: "#475569", fontWeight: "700" }}>
                Valor Anterior
              </th>
              <th style={{ padding: "12px 14px", color: "#475569", fontWeight: "700" }}>
                Valor Novo
              </th>
            </tr>
          </thead>
          <tbody>
            {historicoFiltrado.map((h) => (
              <tr key={h.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "10px 14px", color: "#64748b", whiteSpace: "nowrap" }}>
                  {formatarDataHora(h.timestamp)}
                </td>
                <td style={{ padding: "10px 14px", fontWeight: "600", color: "#0f172a" }}>
                  {h.tipo}
                </td>
                <td style={{ padding: "10px 14px", color: "#334155" }}>
                  {h.contexto || "-"}
                </td>
                <td style={{ padding: "10px 14px", color: "#b91c1c" }}>
                  {formatarValorHistorico(h.valorAnterior)}
                </td>
                <td style={{ padding: "10px 14px", color: "#15803d", fontWeight: "600" }}>
                  {formatarValorHistorico(h.valorNovo)}
                </td>
              </tr>
            ))}
            {historicoFiltrado.length === 0 && (
              <tr>
                <td
                  colSpan="5"
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#94a3b8",
                    fontWeight: "600",
                  }}
                >
                  Nenhuma edição encontrada para os critérios aplicados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="cartoes-mobile">
        {historicoFiltrado.map((h) => (
          <CardMobile
            key={h.id}
            titulo={h.tipo}
            badge={
              <span
                style={{
                  fontSize: "11px",
                  color: "#64748b",
                  whiteSpace: "nowrap",
                }}
              >
                {formatarDataHora(h.timestamp)}
              </span>
            }
            resumo={[
              { label: "Contexto", valor: h.contexto || "-" },
              { label: "Valor Novo", valor: formatarValorHistorico(h.valorNovo) },
            ]}
            detalhes={[
              {
                label: "Valor Anterior",
                valor: formatarValorHistorico(h.valorAnterior),
              },
            ]}
          />
        ))}
        {historicoFiltrado.length === 0 && (
          <p
            style={{
              padding: "40px",
              textAlign: "center",
              color: "#94a3b8",
              fontWeight: "600",
            }}
          >
            Nenhuma edição encontrada para os critérios aplicados.
          </p>
        )}
      </div>
    </div>
  );
}
